import { Select } from '@mantine/core';
import { CONTENT_BASE_LANGUAGE } from '@routellers/types/dist/shared/content-base-language';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { api } from '../api';

type Props = {
    cityId: number | null;
    value: number | null;
    onChange: (districtId: number | null) => void;
    label?: string;
    description?: string;
    disabled?: boolean;
};

export const DistrictSelect = ({ cityId, value, onChange, label, description, disabled }: Props) => {
    const { t } = useTranslation();
    const [options, setOptions] = useState<{ value: string; label: string }[]>([]);

    useEffect(() => {
        if (!cityId) {
            setOptions([]);

            return;
        }

        let cancelled = false;

        api.cityDistrictsApi
            .query({
                page: 1,
                limit: 100,
                sort: 'title',
                order: 'ASC',
                where: { cityId },
            })
            .then(({ data }) => {
                if (cancelled) return;

                setOptions(
                    (data?.items || []).map((row) => {
                        const name =
                            row.locales?.find(
                                (locale) =>
                                    locale.language === CONTENT_BASE_LANGUAGE && locale.name?.trim(),
                            )?.name || row.title;

                        return { value: String(row.id), label: name };
                    }),
                );
            })
            .catch(() => {
                if (!cancelled) setOptions([]);
            });

        return () => {
            cancelled = true;
        };
    }, [cityId]);

    return (
        <Select
            label={label ?? t('pages.districts.editor.district')}
            description={description}
            data={options}
            value={value == null ? null : String(value)}
            onChange={(next) => onChange(next ? Number(next) : null)}
            clearable
            searchable
            disabled={disabled || !cityId}
            placeholder={cityId ? t('pages.districts.selectPlaceholder') : t('pages.districts.selectNeedsCity')}
        />
    );
};
